export default "__VITE_ASSET__D$jX59jp__"